import { render, staticRenderFns } from "./ContactsSent.vue?vue&type=template&id=4e0a21d9&scoped=true"
import script from "./ContactsSent.vue?vue&type=script&lang=js"
export * from "./ContactsSent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0a21d9",
  null
  
)

export default component.exports